import type { IRole } from "@/interfaces";

export const colors: Record<IRole & "medical-service-provider", string> = {
  "super-admin": "#CCA829",
  "local-admin": "#564766",
  doctor: "#0C6291",
  staff: "#CC2936",
  patient: "#AB29CC",
  admin: "#3AA3B0",
  "medical-service-provider-lab": "#C1666B",
  "medical-service-provider-drug": "#48A9A6",
  "medical-service-provider-image": "#F67E7D",
  "medical-service-provider": "#48A9A6",
  "inactive-patient": "#AB29CC",
};
